import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import CenterTable from './atoms/center_table';
import CreateNewCenter from './details/create';

const Centers = (props) => {
  const { setGModal } = props;
  const [refresh, setReFresh] = useState(new Date());

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '4.6rem',
          alignItems: 'center',
          padding: '0rem 1rem 0rem 1rem',
          background: 'rgba(115, 103, 240, 0.16)',
          border: '1px solid rgba(115, 103, 240, 0.16)',
          borderRadius: '0.6rem',
          // font
          fontFamily: 'Public Sans',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '1.5rem',
          lineHeight: '2.2rem',
          color: '#7367F0',
        }}
      >
        {`어플을 설치한 후 회원가입한 센터 리스트`}
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          marginTop: '2.6rem',
          background: '#FFF',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '5.6rem',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0rem 2.4rem 0rem 2.4rem',
            // font
            fontFamily: 'Public Sans',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '1.8rem',
            lineHeight: '2.4rem',
          }}
        >
          <div> {`센터 리스트`}</div>
          <Button
            type="primary"
            // htmlType={'submit'}
            // loading={loading}
            style={{
              display: 'flex',
              width: '21.3rem',
              height: '3.4rem',
              justifyContent: 'center',
              alignItem: 'center',
              background: '#7367F0',
              // font
              fontWeight: 600,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
            onClick={(e) => {
              setGModal((prev) => {
                return {
                  ...prev,
                  show: true,
                  component: (
                    <CreateNewCenter {...props} setReFresh={setReFresh} />
                  ),
                };
              });
            }}
          >
            {`새로운 센터 추가`}
          </Button>
        </div>
        <CenterTable {...props} refresh={refresh} />
      </div>
    </div>
  );
};

export default Centers;
